import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {OrderSettlement} from "../order-settlement.model";

export class OrderSettlementDgSearchResults extends GenericDgSearchResults {
  public results: OrderSettlement[];

  constructor(total: number, results: OrderSettlement[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

